// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1z1_M","row":"Node_row__2hoW1","label":"Node_label__2FRdq","footer":"Node_footer__2cWQX"};